$(document).ready(function () {
    $('.js-btn-plus').hover(function () {
        $('.js-show__name').fadeIn(800);
        $(this).fadeOut(800);
    });
});